import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { InputComponent } from 'src/app/components/shared/input';
import { CategoryService } from 'src/app/services/category';
import { LocaleService } from 'src/app/services/locale';
import { DropdownComponent } from '../../../../shared/dropdown';
import { TrashComponent } from '../../../../icons/trash';
import { PlusComponent } from '../../../../icons/plus';

@Component({
  selector: 'app-category1-question2',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputComponent,
    DropdownComponent,
    TrashComponent,
    PlusComponent
  ],
  template: `
    <div class="text-[13px]">
      {{ strings[language].question }}
    </div>
    <div class="text-[12px] text-[#616161] mt-1">
      {{ strings[language].answer }}
    </div>
    <br />
    <div class="flex flex-wrap gap-4 sm:gap-6">
      <div
        (click)="usage = true"
        class="flex gap-2 align-middle items-center cursor-pointer text-[13px]"
      >
        <div
          [ngClass]="{ 'bg-[#183A25]': usage }"
          class="w-4 h-4 border border-gray-500 rounded-full flex-shrink-0"
        ></div>
        <div>{{ strings[language].choice_yes }}</div>
      </div>
      <div>
        <div
          (click)="usage = false"
          class="flex gap-2 align-middle items-center cursor-pointer text-[13px]"
        >
          <div
            [ngClass]="{
              'bg-[#183A25]': !usage
            }"
            class="w-4 h-4 border border-gray-500 rounded-full flex-shrink-0"
          ></div>
          <div>{{ strings[language].choice_no }}</div>
        </div>
      </div>
    </div>
    <div *ngIf="usage">
      <div class="bg-[#043B22] flex px-3 py-2.5 rounded-t-lg gap-4 mt-6 items-center">
        <div class="text-white text-[13px] flex-1">
          {{ strings[language].label_fuel_type }}
        </div>
        <div class="text-white text-[13px] flex-1">
          {{ strings[language].label_liters_consumed }}
        </div>
        <div
          (click)="createForm()"
          class="w-6 h-6 flex justify-center items-center cursor-pointer bg-white/20 hover:bg-white/30 rounded-full transition-colors"
        >
          <app-plus color="white"></app-plus>
        </div>
      </div>
      <div
        *ngFor="let fuel of fossilFuelControls; let x = index"
        class="flex py-4 px-1 border-y border-[#DEE2E6] gap-5"
      >
        <div class="w-1/2">
          <app-dropdown
            (change)="onKeyUp()"
            placeholder="{{ strings[language].select }} {{
              strings[language].label_fuel_type
            }}"
            [options]="[
              {
                value: this.strings[this.language].diesel,
                label: this.strings[this.language].diesel
              },
              {
                value: this.strings[this.language].gas,
                label: this.strings[this.language].gas
              },
              {
                value: this.strings[this.language].fuel,
                label: this.strings[this.language].fuel
              }
            ]"
            [control]="fuel.row['fuel']"
          ></app-dropdown>
        </div>
        <div class="w-1/2">
          <app-input
            [keyUp]="onKeyUp"
            [index]="x"
            type="number"
            [dollar]="false"
            unit="l"
            placeholder="0.00"
            [control]="fuel.row['liters']"
          >
          </app-input>
        </div>
        <div
          (click)="fossilFuelControls.pop()"
          class="w-1/9 flex justify-end pl-1 align-middle items-center cursor-pointer"
        >
          <app-trash></app-trash>
        </div>
      </div>
    </div>
  `
})
export class Category1Question2Component {
  language = inject(LocaleService).getLanguage();
  categoryService = inject(CategoryService);
  categories = this.categoryService.categories();

  usage = false;

  fossilFuelControls = [
    {
      row: {
        fuel: new FormControl('', Validators.required),
        liters: new FormControl('', Validators.required)
      }
    }
  ];

  form = new FormGroup({
    rows: new FormControl(this.fossilFuelControls)
  });

  strings: any = {
    english: {
      question: 'Do you consume other fossil fuels?',
      answer: 'Please fill in the required data if yes to proceed.',
      choice_yes: 'Yes',
      choice_no: 'No',
      label_fuel_type: 'Fuel type',
      label_liters_consumed: 'Liters consumed',
      select: 'Select',
      diesel: 'Diesel',
      gas: 'Gasoline',
      fuel: 'Fuel Oil',
      hybrid: 'Hybrid'
    },
    italian: {
      question: 'Consumi altri combustibili fossili?',
      answer:
        'Si prega di inserire i dati richiesti se la risposta è sì per procedere.',
      choice_yes: 'Sì',
      choice_no: 'No',
      label_fuel_type: 'Tipo di combustibile',
      label_liters_consumed: 'Litri consumati',
      select: 'Seleziona',
      diesel: 'Diesel',
      gas: 'Benzina',
      fuel: 'Olio combustibile',
      hybrid: 'Ibrido'
    }
  };

  ngOnInit() {
    let categories = localStorage.getItem('categories');

    if (categories) {
      categories = JSON.parse(categories);
      // @ts-ignore
      const answers = categories[0].questions[1].answers;
      if (answers?.length > 0) {
        let newControls: any = [];

        // @ts-ignore
        answers?.map((ex: any) => {
          newControls.push({
            row: {
              fuel: new FormControl(ex.fuel, Validators.required),
              liters: new FormControl(ex.liters, Validators.required)
            }
          });
        });

        this.usage = true;

        this.fossilFuelControls = newControls;
        this.form.setValue({ rows: newControls });
      }
    }
  }

  createForm = () => {
    this.fossilFuelControls.push({
      row: {
        fuel: new FormControl('', Validators.required),
        liters: new FormControl('', Validators.required)
      }
    });
  };

  onKeyUp = () => {
    try {
      let newAnswers = this.form.value.rows?.map(row => {
        return { fuel: row.row.fuel.value, liters: row.row.liters.value };
      });

      // @ts-ignore
      this.categories[0].questions[1].answers = newAnswers;

      this.categoryService.persistCategories(this.categories);
    } catch (error) { }
  };
}
